import {
  CreateExperienceProductTargetingFeDto,
  ExperienceProductTargetingFeDto,
} from "@intelligems/ig-types";

export interface IExperienceProductTargetingState {
  isSuccess: boolean;
  experienceProductTargeting: CreateExperienceProductTargetingFeDto[];
  storedExperienceProductTargeting: ExperienceProductTargetingFeDto[];
}

export const initialIExperienceProductTargetingState: IExperienceProductTargetingState =
  {
    isSuccess: false,
    experienceProductTargeting: [],
    storedExperienceProductTargeting: [],
  };
